import type {ProposalQuoteSource} from '@artemis-group/aiw-contracts';
import {useT} from '../lib/i18n';
import {money} from '../lib/format';
export function ProposalQuoteSources({sources}:{sources:ProposalQuoteSource[]}){
 const {t}=useT();
 if(!sources.length)return null;
 return <details className="mb-5 space-y-4 rounded-lg border bg-card p-3">
  <summary className="cursor-pointer text-sm font-semibold">{t('proposal.source.title')}</summary><p className="text-sm">{t('proposal.source.explanation')}</p>
  {sources.length>1&&<p className="text-sm" role="status">{t('proposal.source.multiple')}</p>}
  {sources.map(source=><div key={`${source.quote_id}:${source.source_hash}`}>
   <h3 className="font-semibold">{source.label} · {money(source.subtotal)} + GST</h3>
   {!source.lines.length?<p className="text-sm">{t('proposal.source.empty')}</p>:<div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr className="border-b text-left">
    <th className="py-2">{t('priced.col.line')}</th><th>{t('common.quantity')}</th><th>{t('priced.col.rate')}</th><th>{t('priced.col.sell')}</th>
   </tr></thead><tbody>{source.lines.map((line,i)=><tr key={`${line.id}:${i}`} className="border-b">
    <td className="py-2">{line.name}{line.colour?` · ${line.colour}`:''}{line.area&&<span className="block text-muted-foreground">{line.area}</span>}</td>
    <td>{line.quantity} {line.unit}</td><td>{line.unit_sell==null?'—':money(line.unit_sell)}</td><td>{line.line_sell==null||line.line_sell===0?t('proposal.source.included'):money(line.line_sell)}</td>
   </tr>)}</tbody></table></div>}
   <p className="mt-2 text-sm">{t('commercial.total')}: {money(source.subtotal)} + GST</p>
  </div>)}
 </details>;
}
